module.exports = __webpack_public_path__ + "static/media/jumbo1.e4234280.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ebs/images/jumbo1.png
// module id = 578
// module chunks = 0